export interface IMarketType {
  marketTypeId: number;
  name: string;
  code: string;
}

export class MarketType implements IMarketType {
  marketTypeId: number;
  name: string;
  code: string;
}
